import { integer, jsonb, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getTimestampWithTimezone,
} from '../common/utils'

export type SlotBreakdown = {
  today: number
  tomorrow: number
  in2Days: number
  in3Days: number
  in4PlusDays: number
}

export const bookingAnalytics = pgTable(
  'booking_analytics',
  {
    ...getBaseFields(),
    street: text().notNull(),
    postalCode: text(),
    city: text(),
    durationMinutes: integer().notNull(),
    slotsFound: integer().notNull(),
    earliestSlotTime: getTimestampWithTimezone(),
    latestSlotTime: getTimestampWithTimezone(),
    uniqueEmployees: integer().notNull().default(0),
    slotBreakdown: jsonb().$type<SlotBreakdown>(),
  },
  (table) => getBaseIndexes('booking_analytics', table),
)
